/* Size sheet (snippets/size-sheet.liquid): one sheet for every product card whose piece comes in sizes. A card's "+"
   ([data-quick-add-choose], assets/quick-add.js) calls LMB.sizeSheet.open(card, button); the sheet is filled from
   the card's <script type="application/json" data-card-sheet> (title, code, url, image, price, variants).
   Choosing a size turns "Add to bag · $8" into a [data-quick-add="<variant id>"] button, which quick-add.js adds
   (/cart/add.js, bag stays closed, toast) and then closes the sheet: the sheet itself never adds. Until a size is
   chosen the button is aria-disabled and says "Choose your size first". Sizes are radios, so arrow keys move
   between them; sold-out sizes are struck through and disabled. Never changes the URL. */
(() => {
  const LMB = (window.LMB = window.LMB || {});
  if (LMB.sizeSheet) return;
  const overlay = document.getElementById('SizeSheet');
  if (!overlay) return;

  const thumb = overlay.querySelector('[data-size-sheet-thumb]');
  const code = overlay.querySelector('[data-size-sheet-code]');
  const title = overlay.querySelector('[data-size-sheet-title]');
  const price = overlay.querySelector('[data-size-sheet-price]');
  const sizes = overlay.querySelector('[data-size-sheet-sizes]');
  const status = overlay.querySelector('[data-quick-add-status]');
  const addButton = overlay.querySelector('[data-size-sheet-add]');
  const t = (key, fallback) => (LMB.strings && LMB.strings[key]) || fallback;
  const money = (cents) => (LMB.formatMoney ? LMB.formatMoney(cents) : `$${Math.round(cents) / 100}`);

  let product = null;
  let trigger = null;

  /* Price, with the old price struck through only when it is higher (like snippets/price.liquid). */
  function renderPrice(amount, compare) {
    price.replaceChildren(document.createTextNode(money(amount)));
    if (compare && compare > amount) {
      const struck = document.createElement('s');
      struck.className = 'price__compare';
      const label = document.createElement('span');
      label.className = 'visually-hidden';
      label.textContent = t('regular_price', 'Regular price');
      struck.append(label, document.createTextNode(money(compare)));
      price.append(struck);
    }
  }

  function setChoice(variant) {
    const amount = variant ? variant.price : product.price;
    renderPrice(amount, variant ? variant.compare_at : product.compare_at);
    addButton.textContent = t('sheet_add', 'Add to bag · [price]').replace('[price]', money(amount));
    if (variant) {
      addButton.dataset.quickAdd = variant.id;
      addButton.removeAttribute('aria-disabled');
      status.textContent = '';
    } else {
      addButton.removeAttribute('data-quick-add');
      addButton.setAttribute('aria-disabled', 'true');
    }
  }

  function renderSizes() {
    sizes.replaceChildren();
    product.variants.forEach((variant, index) => {
      const id = `SizeSheet-size-${index}`;
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = 'SizeSheet-size';
      input.id = id;
      input.value = variant.id;
      input.className = 'ssheet__radio visually-hidden';
      input.disabled = !variant.available;
      const label = document.createElement('label');
      label.htmlFor = id;
      label.className = 'ssheet__size';
      label.textContent = variant.title;
      if (!variant.available) {
        const soldOut = document.createElement('span');
        soldOut.className = 'visually-hidden';
        soldOut.textContent = `, ${t('sold_out', 'Sold out')}`;
        label.append(soldOut);
      }
      sizes.append(input, label);
    });
  }

  function open(card, opener) {
    const script = card && card.querySelector('[data-card-sheet]');
    if (!script) return;
    try {
      product = JSON.parse(script.textContent);
    } catch (error) {
      product = null;
    }
    if (!product || !Array.isArray(product.variants) || !product.variants.length) {
      if (opener && opener.dataset.productUrl) window.location.href = opener.dataset.productUrl;
      return;
    }
    trigger = opener || null;

    thumb.replaceChildren();
    if (product.image) {
      const img = document.createElement('img');
      img.src = product.image;
      img.alt = '';
      img.width = 52;
      img.height = 65;
      thumb.append(img);
    }
    code.textContent = product.code || '';
    title.textContent = product.title || '';
    status.textContent = '';
    renderSizes();

    // A single size left is chosen for the shopper; otherwise nothing is, so no one adds a size by accident.
    const available = product.variants.filter((variant) => variant.available);
    const preset = available.length === 1 ? available[0] : null;
    if (preset) sizes.querySelector(`input[value="${preset.id}"]`).checked = true;
    setChoice(preset);

    // Focus lands on the chosen size, else the first one that can be picked.
    sizes.querySelectorAll('[autofocus]').forEach((el) => el.removeAttribute('autofocus'));
    const first = sizes.querySelector('input:checked') || sizes.querySelector('input:not(:disabled)');
    if (first) first.setAttribute('autofocus', '');
    overlay.open(opener);
  }

  sizes.addEventListener('change', (event) => {
    const input = event.target.closest('input[type="radio"]');
    if (!input || !product) return;
    setChoice(product.variants.find((variant) => String(variant.id) === input.value) || null);
  });

  /* "Add to bag" with no size chosen: say so and go to the sizes (the add itself is quick-add.js's, once chosen). */
  addButton.addEventListener('click', () => {
    if (addButton.hasAttribute('data-quick-add')) return;
    // Emptied first, so a second press is read out again.
    status.textContent = '';
    requestAnimationFrame(() => {
      status.textContent = t('sheet_choose_first', 'Choose your size first');
    });
    const first = sizes.querySelector('input:not(:disabled)');
    if (first) first.focus();
  });

  LMB.sizeSheet = {
    open,
    close: () => overlay.close(),
    trigger: () => (trigger && trigger.isConnected ? trigger : null),
  };
})();
